
import { Component, OnInit, Output, EventEmitter, ViewEncapsulation, AfterViewInit , AfterViewChecked, OnDestroy, Input} from '@angular/core';
import { FormBuilder, FormGroup, FormControl, UntypedFormBuilder } from '@angular/forms';
import { Utility } from '../../shared/utility/utility';
import { CustomValidators } from '../../shared/utility/custom-validator';
import { AjaxService } from '../../services/ajax.service';
import { AppDetailsService } from '../../services/app-details.services';
import { EmitterService } from '../../services/emitter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { countryUserCurrencies, policiesTypes, restOfTheWorldCurrencies } from '../../shared/utility/config';
import 'intl-tel-input';
import { UserDetailsService } from '../../services/user-details.service';
import { BannerService } from '../../services/banner.service';
import { FormValidationComponent } from '../../form-validation/form-validation.component';
import { TranslateService } from "@ngx-translate/core";
import { ChangeDetectorRef } from '@angular/core';
import { CountryDataService } from '../../services/country.service';
import { language,timerBannerRunningTime, bannerState } from '../../shared/utility/config';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { SocketService } from "../../services/socket.service";
import { PoliciesVersionService } from '../../services/policies-version.service';
import { environment } from '../../../environments/environment';
import * as _ from 'underscore';
@Component({
  selector: 'app-registration-step-one',
  templateUrl: './registration-step-one.component.html',
  styleUrls: ['./registration-step-one.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegistrationStepOneComponent extends FormValidationComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  focusedElement;
  ipCountry;
  viewPassword: boolean = false;
  availableCurrency;
  serverError = [];
  message;
  focusPassword = false;
  userCountry;
  langCode;
  ecrIdValue;
  prevUrl;
  bannerState: bannerState;
  isSubmitted = false;
  @Output() loginComplete = new EventEmitter<string>();

  @Input()
  fromNavBar:boolean = false;
  @Output() stepOneOkay = new EventEmitter<string>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  configuredPolicesData:Array<Object>=[];
  clonedPoliciesTypes;
  toggleSwedenLable;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private utils: Utility,
    public CustomValidators: CustomValidators,
    private ajaxService: AjaxService,
    private appDetails: AppDetailsService,
    private emitterService: EmitterService,
    private router: Router,
    private userDetailsService: UserDetailsService,
    private bannerService: BannerService,
    public translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    private countryDataService: CountryDataService,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private policiesVersionService:PoliciesVersionService

  ) {
    super(utils);
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.clonedPoliciesTypes = Object.values(policiesTypes);
    if(this.countryDataService.ipCountry == "SE"){
      this.emitterService.toggleLabelForSweden$.pipe(takeUntil(this.destroy$)).subscribe(status=>{
        this.toggleSwedenLable = status
      })
    }
  }

  isShowDrop = false;
   
  toggleDropdown() {
    this.isShowDrop = !this.isShowDrop;
  }
  
  signUpStepOne = this.formBuilder.group({
    'firstName': ['', [this.CustomValidators.validName(2, 30)]],
    'lastName': ['', [this.CustomValidators.validName(2, 30)]],
    'emailId': ['',{updateOn: 'blur', validators:[this.CustomValidators.validateUniqueness("txtEmail", this.ajaxService, true)]}],
    //'username': ['', [this.CustomValidators.validateUniqueness("txtNickname", this.ajaxService, true),this.CustomValidators.validateUsername()]],
    'pwd': ['', this.CustomValidators.validatePassword(8)],
    'currencyCode': ['', [this.CustomValidators.required]],
    'areaCode': ['', this.CustomValidators.required],
    'areaCountryCode': ['', this.CustomValidators.required],
    'phoneNumber': ['', [this.CustomValidators.phoneNumberValidator]],
    'termsNcondition': ['', [this.CustomValidators.required]],
    'emailAndMobileSubscribed': ['', [this.CustomValidators.required]]
  })
  ngOnInit() {
    this.getCountry();
    this.getPolicies();
    this.translateService.get(['errors']).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.signUpStepOne = this.formBuilder.group({
        'firstName': ['', [this.CustomValidators.validName(2, 30)]],
        'lastName': ['', [this.CustomValidators.validName(2, 30)]],
        'emailId': ['', {updateOn: 'blur', validators:[this.CustomValidators.validateUniqueness("txtEmail", this.ajaxService, true)]}],
        //'username': ['', [this.CustomValidators.validateUniqueness("txtNickname", this.ajaxService, true),this.CustomValidators.validateUsername()]],
        'pwd': ['', this.CustomValidators.validatePassword(8)],
        'currencyCode': ['', [this.CustomValidators.required]],
        'areaCode': ['', this.CustomValidators.required],
        'areaCountryCode': ['', this.CustomValidators.required],
        'phoneNumber': ['', [this.ipCountry == 'SE' ? this.CustomValidators.phoneNumberValidatorSE(this.utils) : this.CustomValidators.phoneNumberValidator]],
        'termsNcondition': ['', [this.CustomValidators.required]],
        'emailAndMobileSubscribed': ['', [this.CustomValidators.required]]
      }, { validator: this.CustomValidators.validateCheckMobile(this.ajaxService, false, "", this.countryDataService, this.utils) })

    });
    let field = this.userDetailsService.getbannerFieldsComplete();
    if (!field) {
      this.signUpStepOne.reset();
    }
      /*GTM event to trigger as soon as the step 1 form loaded */
      this.utils.gtmEvent("registerStart", {
        evntType: "registerStart"
      });
     if(location.pathname.includes('/register')){
        this.utils.registrationCaptureRouteData();
     }
     this.updateRegistrationForm(this.utils.registrationPrefillingData)
  }

  updateRegistrationForm(params){
    if(params && !_.isEmpty(params)){
      let { name,email,surname,phone} = params;
      this.signUpStepOne.controls['firstName'].setValue(name);
      this.signUpStepOne.controls['lastName'].setValue(surname);
      this.signUpStepOne.controls['phoneNumber'].setValue(phone);
      this.signUpStepOne.controls['emailId'].setValue(email);
      this.utils.validateAllFormFields(this.signUpStepOne)
    }else{
      params = localStorage.getItem('regPreData') ? localStorage.getItem('regPreData') : null;
      if(params){
        params = JSON.parse(params);
        this.updateRegistrationForm(params);
      }
    }
  }
  getPolicies() {
    if(!this.policiesVersionService.configuredPolicies?.length){
      this.policiesVersionService.getPolicies().pipe(takeUntil(this.destroy$)).subscribe(data => {
        if (data && data['status'] === "SUCCESS") {
          this.configuredPolicesData = data['policyConfigs'];
        }
      })
    }else{
      this.configuredPolicesData = this.policiesVersionService.configuredPolicies;
    }
  }
  getCountry() {

    Promise.resolve(this.countryDataService.getCountriesDetails()).then(regData => {
      this.initialstep();
    });
  }
  updateFormFields() {
    let fields = this.userDetailsService.getbannerFieldsComplete();
    if (fields) {
      this.signUpStepOne.controls["firstName"].setValue(fields["firstName"]);
      this.signUpStepOne.controls["lastName"].setValue(fields["lastName"]);
      if (fields["phoneNumber"]) this.signUpStepOne.controls["phoneNumber"].setValue(fields["phoneNumber"]);
      if (fields["areaCountryCode"]) {
        this.signUpStepOne.controls["areaCode"].setValue(fields["areaCode"])
        this.utils.setPhoneNumberDropdown("phoneNumberFlag", fields["areaCountryCode"], this.signUpStepOne);
      }
      this.signUpStepOne.controls["firstName"].markAsTouched({ onlySelf: true });
      this.signUpStepOne.controls["firstName"].markAsDirty({ onlySelf: true });
      this.signUpStepOne.controls["lastName"].markAsTouched({ onlySelf: true });
      this.signUpStepOne.controls["lastName"].markAsDirty({ onlySelf: true });
      this.signUpStepOne.controls["phoneNumber"].markAsTouched({ onlySelf: true });
      this.signUpStepOne.controls["phoneNumber"].markAsDirty({ onlySelf: true });
      this.signUpStepOne.controls["areaCountryCode"].markAsTouched({ onlySelf: true });
      this.signUpStepOne.controls["areaCountryCode"].markAsDirty({ onlySelf: true });
    }
    this.signUpStepOne.controls['termsNcondition'].setValue(true)
    this.signUpStepOne.controls['emailAndMobileSubscribed'].setValue(true);
  }

  initialstep() {
    let avCurrencyData = this.appDetails.getAvailableCurrencies();
    if (avCurrencyData) {
      this.setFirstStepReqData(avCurrencyData);
    } else {
      Promise.resolve(this.countryDataService.getEnabledCurrencies()).then(currencyData => {
        this.appDetails.setAvailableCurrencies(currencyData);
        this.setFirstStepReqData(currencyData);
      },
      SystemError => {
      });
    }
  }

  setFirstStepReqData(currencyData) {
    this.ipCountry = this.countryDataService.ipCountry;
    if(environment.pnpCountryList.indexOf(this.ipCountry) >= 0){
      location.href = this.langCode
      return
    }

    if(!this.signUpStepOne.controls["areaCountryCode"].value) this.signUpStepOne.controls["areaCountryCode"].setValue(this.ipCountry);
    
    let validCurrency=[];
    if (currencyData && currencyData["currency"]) {
      validCurrency = currencyData["currency"];
    }

    this.availableCurrency = validCurrency.length>0?restOfTheWorldCurrencies.filter(c=>validCurrency.includes(c)):restOfTheWorldCurrencies;
    
    const configCountries=countryUserCurrencies.flatMap(c=>c.countries);

    if(configCountries.includes(this.ipCountry)){
      const configCountry=countryUserCurrencies.find(c=>c.countries.includes(this.ipCountry));
      if (configCountry!==undefined) {
        this.availableCurrency = validCurrency.length>0?configCountry["currencies"].filter(c=>validCurrency.includes(c)):configCountry["currencies"];
      }

    }

    if(this.availableCurrency.length<=0){
      this.signUpStepOne.controls["currencyCode"].setValue(restOfTheWorldCurrencies[0]);
    }else{
      this.signUpStepOne.controls["currencyCode"].setValue(this.availableCurrency[0]);
    }

    setTimeout(() => {
      this.utils.setPhoneNumberDropdown("phoneNumberFlag", this.signUpStepOne.controls["areaCountryCode"].value, this.signUpStepOne);
      if (!this.signUpStepOne.controls["areaCode"].value) this.signUpStepOne.controls["areaCode"].setValue($("#phoneNumberFlag").intlTelInput("getSelectedCountryData").dialCode);
    }, 100);
  }
  moveToLogin() {
    this.router.navigate([this.langCode + '/login']);
  }
  marketingAndComm(){
    this.router.navigate([this.langCode+'/page/marketing-communication'])
  }
  termsAndCond(){
    this.router.navigate([this.langCode+'/page/terms-and-conditions'])
  }
  bonusrules(){
    this.router.navigate([this.langCode+'/page/bonus-rules'])
  }
  ngAfterViewInit() {
    this.updateFormFields();
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  checkmobilereg(buttonId, check) {
    if(buttonId){
      this.isSubmitted = true;
      this.utils.validateAllFormFields(this.signUpStepOne);
    }
    /* checking user login status, if user is already logged in, loading the homepage else going with registration flow */
    Promise.resolve(this.ajaxService.getLoginStatus()).then(data => {
      if (data['status']) {
        this.appDetails.loadHomepage(this.langCode);
      }else if (this.signUpStepOne.valid){
      let message;
      let signUpData = this.utils.formControlToParams(this.signUpStepOne, {});
      let trimmedNumber = this.utils.trimNumberBasedOnCountryRequirement(this.ipCountry, signUpData)
      let validateValues = {
        mobileNumber: trimmedNumber,
        mobileIsdCode: signUpData.areaCode
      }
      if (!signUpData.phoneNumber || !signUpData.areaCode) {
        let message = { 'message': CustomValidators.translationService.instant('errors.error10') };
        this.signUpStepOne.controls['phoneNumber'].setErrors(message);
      }
      else {
        Promise.resolve(this.userDetailsService.checkmobilereg(validateValues))
          .then(data => {
            if (data !== "already exists") {
              if (check) {
                if (this.signUpStepOne.valid) {
                  this.registerUser(buttonId);
                  this.signUpStepOne.controls['phoneNumber'].setErrors(null);
                }
                else {
                  this.utils.validateAllFormFields(this.signUpStepOne);
                }
              }
            } else {
              message = { 'message': CustomValidators.translationService.instant('errors.error40') }
              this.signUpStepOne.controls['phoneNumber'].setErrors(message);
            }
          })
      }
    } else {
      this.utils.validateAllFormFields(this.signUpStepOne);
    }
  });  
  }
  trimPassword(){
    let password = this.signUpStepOne.controls['pwd'].value;
      this.signUpStepOne.controls['pwd'].setValue(password.trim())
  }
  registerUser(buttonId) {
    if (this.signUpStepOne.valid) {
      localStorage.setItem('showRegisterPage','true');
      this.utils.disableNewButton(buttonId);
      this.serverError = [];
      /*Clean the form of unnecessary spaces*/
      this.signUpStepOne = this.userDetailsService.cleanForm(this.signUpStepOne);
      let signUpData = this.utils.formControlToParams(this.signUpStepOne, {});
       
      let phoneNumber = this.utils.trimNumberBasedOnCountryRequirement(this.ipCountry, signUpData);
      signUpData['phoneNumber'] = phoneNumber;
      //signUpData['emailAndMobileSubscribed'] = this.signUpStepOne.controls["emailAndMobileSubscribed"].value ? "true" : "false";
      signUpData["password"] = (signUpData["pwd"]).trim();
      // signUpData["confirmPassword"] = signUpData["pwd"];
      signUpData["screenName"] = signUpData["emailId"];
      signUpData['affiliateId'] = this.utils.getAffliateId('affiliate');
      signUpData['affiliateName'] = this.utils.getAffliateId('affiliatename');
      signUpData['trackerId'] = this.utils.getAffliateId('tracker');
      if(this.utils.getAffliateId('cvalue')){
          signUpData['bannerId'] = this.utils.getAffliateId('cvalue');
      }
      if ((this.configuredPolicesData && this.configuredPolicesData.length > 0) || (this.policiesVersionService.configuredPolicies && this.policiesVersionService.configuredPolicies?.length > 0)) {
        signUpData["policies"] = this.policiesVersionService.sendNewUpdatedPolicy(true);
      }
      signUpData["language"] = language[this.langCode];
      delete signUpData["username"];
      console.log(signUpData)
      Promise.resolve(this.ajaxService.doRegistration(signUpData))
        .then(
          registrationResponse => {
            if (registrationResponse && registrationResponse["success"]!==undefined && registrationResponse["success"] === true) {
              this.ecrIdValue = registrationResponse["externalEcrId"];
              let logincredentials = {
                'emailId': signUpData["emailId"],
                'password': signUpData["password"]
              }
              Promise.resolve(this.ajaxService.doLogin(logincredentials))
                .then(
                  data => {
                    if (data && Boolean(data["success"]) === true) {
                      this.emitterService.broadCastJurisdictionValue(data["userJurisdiction"]);
                      localStorage.removeItem('regPreData');
                      localStorage.setItem("hashedPassword",logincredentials.password)
                      localStorage.setItem("gtmLoggedInEvent", "login");
                      this.socketService.connectToScoket(
                        data["pragmaticUrl"],
                        data["pragmaticSessionId"]
                      );
                      /*For Server to Server calls for cpl */
                      this.utils.S2Scalls(signUpData, "registration");

                      /*GTM event for user registration */
                      this.utils.gtmEvent("userRegistered", {
                        email: signUpData["emailId"],
                        userExternalECR: this.ecrIdValue,
                        username: signUpData["screenName"]
                      });
                      
                      /*For reinitialising the timer banner for that user*/
                      let bannerObj = {
                        "status": bannerState.BANNED,
                        "timeLapse": timerBannerRunningTime
                      }
                      localStorage.setItem("bannerObject", JSON.stringify(bannerObj));
                      if ((window as any).p161) {
                        (window as any).p161.track("3152576");
                      }

                      this.bannerService.clearBanners();
                      this.emitterService.broadcastregistrationSteps("tabTwo");
                      if (data["mobileVerificationStatus"] && data["mobileVerificationStatus"] === "success") {
                        this.userDetailsService.setUserOTPCheck('loginsuccess');
                      }
                      else {
                        this.userDetailsService.setUserOTPCheck('logInOtpCheck');
                      }
                      this.emitterService.broadcastloginComplete("regOne");
                      this.activatedRoute.queryParams.subscribe(params => {
                        this.prevUrl = params['prevUrl'];
                      });
                      if (!this.prevUrl) {
                        this.prevUrl = "";
                      }
                      if (!this.prevUrl && location.href.indexOf('affid') > 0 || location.href.indexOf('CXD') > 0) {
                        this.prevUrl = "/";
                      }

                      if(this.fromNavBar){

                        this.stepOneOkay.emit('success');
                      }else{
                        
                        /* Below if condition (mob_register) is for New registration page for Mobile devices */
                        if (this.router.url.includes('mob_register')) {
                          this.router.navigate([this.langCode + '/mob_register/step2']);
                        } else {
                          this.router.navigate([this.langCode + '/register/step2']);
                        }

                      }

                      

                    }

                    else this.emitterService.broadcastloginComplete("Login Failed After Successfull Registration");
                  },
                  SystemError => { });
              this.utils.enableNewButton(buttonId, "", "Continue", "Continue");
            }
            else {
              if (registrationResponse && registrationResponse["errors"]) {
                this.message = "Something went wrong";
                this.serverError.push(this.message);
                for (let key in registrationResponse["errors"]) {
                  switch (key) {
                    case 'firstName':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["firstName"].setErrors({ 'message': this.message });
                      break;
                    case 'lastName':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["lastName"].setErrors({ 'message': this.message });
                      break;
                    case 'screenName':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["screenName"].setErrors({ 'message': this.message });
                      break;
                    case 'password':
                    // case 'confirmPassword':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["pwd"].setErrors({ 'message': this.message })
                      break;
                    case 'emailId':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["emailId"].setErrors({ 'message': this.message });
                      break;
                    case 'areaCode':
                    case 'internationalPhone':
                    case 'phoneNumber':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["phoneNumber"].setErrors({ 'message': this.message });
                      break;
                    case 'currencyCode':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["currencyCode"].setErrors({ 'message': this.message });
                      break;
                    case 'bonusCode':
                      this.message = this.setServerError(key, registrationResponse["errors"][key]);
                      this.serverError.push(this.setServerError(key, registrationResponse["errors"][key]))
                      this.signUpStepOne.controls["bonusCode"].setErrors({ 'message': this.message });
                      break;
                    default:
                      if(registrationResponse["errors"][key]["lblWarning"]) {
                        this.message = this.setServerError(key, registrationResponse["errors"][key]["lblWarning"]);
                        this.serverError.push(registrationResponse["errors"][key]["lblWarning"])
                      } else if(registrationResponse["errors"][key]["errorDescription"]) {
                        this.message = this.setServerError(key, registrationResponse["errors"][key]['errorDescription']);
                        this.serverError.push(registrationResponse["errors"][key]["errorDescription"])
                      }
                      break;
                  }
                }

                /* Below if condition (mob_register) is for New registration page for Mobile devices */
                if (this.router.url.includes('mob_register')) {
                  this.emitterService.broadcastserverError(this.serverError, "/mob_register");
                } else {
                  this.emitterService.broadcastserverError(this.serverError, "/register");
                }
                
              } else {
                this.message = "Something went wrong";
                this.serverError.push(this.message);
                /* Below if condition (mob_register) is for New registration page for Mobile devices */
                if (this.router.url.includes('mob_register')) {
                  this.emitterService.broadcastserverError(this.serverError, "/mob_register");
                } else {
                  this.emitterService.broadcastserverError(this.serverError, "/register");
                }
              }
              this.utils.enableNewButton(buttonId, "", "Continue", "Continue");
            }
          },
          SystemError => {}
        )
    } else {
      this.utils.enableNewButton(buttonId, "", "Continue", "Continue");
      this.utils.validateAllFormFields(this.signUpStepOne);
    }
  }
  setServerError(key, errorMessage) {
    if (errorMessage && errorMessage.includes("(Anonymous function)")) {
      return "Invalid " + key;
    } else {
      return errorMessage;
    }
  }
  getValidFormContols(formGroup: FormGroup, validControls) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl && control.valid && field !== this.focusedElement) {
        validControls.push(field)
      } else if (control instanceof FormGroup) {
        this.getValidFormContols(control, validControls);
      }
    });
    return validControls;
  }
  shouldShowPwdError(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName)
  }

  // New registration mobile disable submit button
  getButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName)
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
